export enum RegistrationProcessStatus {
  Error = -1,
  Unknown = 0,
  Success = 100,
}

export interface AuthInput {
  readonly identifier: string;
  readonly password: string;
}

export interface AuthToken {
  readonly token: string;
  readonly refreshToken: string;
}

export interface CompanyDomain {
  readonly name: string;
  readonly sysName: string;
  readonly description: string;
}

export interface CompanyProfile {
  readonly companyLicense: number;
  readonly logoBase64: string;
  readonly companyDomain: CompanyDomain;
}

export interface User {
  readonly uid: string;
  readonly userId: string;
  readonly userName: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly middleName: string;
  readonly phoneNumber: string;
  readonly email: string;
  readonly companyPhoneNumber: string;
  readonly groupUid: string;
  readonly companyProfile: CompanyProfile;
}

export interface UserInput {
  readonly firstName?: string;
  readonly lastName?: string;
  readonly middleName?: string;
  readonly phoneNumber?: string;
  readonly email?: string;
  readonly aboutMe?: string;
  readonly companyPhoneNumber?: string;
}

export interface RefreshToken {
  readonly token: string;
  readonly refreshToken: string;
}

export interface RefreshTokenInput {
  readonly token: string;
  readonly refreshToken: string;
}

export interface RegisterUserInput {
  readonly identifier: string;
  readonly email: string;
  readonly password: string;
  readonly company: string;
  readonly termsAndConditions: boolean;
}

export interface RegisterCompanyUserInput {
  readonly companyUid?: string;
  readonly usersInfos: {
    readonly firstName: string;
    readonly email: string;
    readonly lastName: string;
    readonly dateOfBirth: string;
    readonly roleUid: string;
    readonly departmentUid: string;
  }[];
}

export interface RegisterCompanyUser {
  readonly status: RegistrationProcessStatus;
  readonly textLog: string[];
}

export interface ResetPasswordCodeInput {
  readonly email: string;
}

export interface ResetPasswordInput {
  readonly code: string;
  readonly oldPassword: string;
  readonly newPassword: string;
}
